export const widgetGap = (theme) => theme.spacings.xs;
export const KPI_WIDGET_GRID_HEIGHT = 1.6 * 0.8;
export const KPI_WIDGET_HEIGHT = `${(100 * KPI_WIDGET_GRID_HEIGHT + 6 * (KPI_WIDGET_GRID_HEIGHT - 1)).toFixed(2)}px`;
